// Реєстр станцій, для яких є конфіг однолінійної схеми (StationSld).
// Додати станцію = додати її топологію й підписи з документації сюди;
// компоненти схеми правити не треба.
import type { StationSldConfig } from './sldTypes';
import { LUCHKY_TOPOLOGY } from './luchky.topology';
import { LUCHKY_DRAWING } from './luchky.drawing';

export const STATION_SLD: Record<string, StationSldConfig> = {
  luchky: { topology: LUCHKY_TOPOLOGY, drawing: LUCHKY_DRAWING },
};

/** Хто бачить нову схему. Решта акаунтів — попередню, поки її не погоджено. */
export const SLD_LOGINS = ['volodp'];
export const canSeeStationSld = (login?: string | null) =>
  !!login && SLD_LOGINS.includes(login.toLowerCase());
